/* ========================================================================
 * Apricot's Band
* ======================================================================== */

// SCSS
import '../scss/includes/apricot-base.scss';
import '../scss/includes/band.scss';

// javaScript
export default {}